export default {
  GET_USER_DATA_REQUEST: "GET_USER_DATA_REQUEST",
  GET_USER_DATA_SUCCESS: "GET_USER_DATA_SUCCESS",
  GET_USER_DATA_FAIL: "GET_USER_DATA_FAIL",

  GET_NOTIFICATIONS_REQUEST: "GET_NOTIFICATIONS_REQUEST",
  GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_FAIL: "GET_NOTIFICATIONS_FAIL",
  SET_USER_IS_LOADING: "SET_USER_IS_LOADING",

  GET_GOVERNORATES_REQUEST: "GET_GOVERNORATES_REQUEST",
  GET_GOVERNORATES_SUCCESS: "GET_GOVERNORATES_SUCCESS",
  GET_GOVERNORATES_FAIL: "GET_GOVERNORATES_FAIL",

  GET_MAJORS_REQUEST: "GET_MAJORS_REQUEST",
  GET_MAJORS_SUCCESS: "GET_MAJORS_SUCCESS",
  GET_MAJORS_FAIL: "GET_MAJORS_FAIL",

  GET_GRADES_REQUEST: "GET_GRADES_REQUEST",
  GET_GRADES_SUCCESS: "GET_GRADES_SUCCESS",
  GET_GRADES_FAIL: "GET_GRADES_FAIL",

  GET_USER_GROUPS_REQUEST: "GET_USER_GROUPS_REQUEST",
  GET_USER_GROUPS_SUCCESS: "GET_USER_GROUPS_SUCCESS",
  GET_USER_GROUPS_FAIL: "GET_USER_GROUPS_FAIL",
};
